var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdlogoH({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.09 119.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{isolation:isolate;}.cls-2{fill:#d40a3f;}.cls-16,.cls-3{mix-blend-mode:overlay;}.cls-4{fill:#454b51;}.cls-5{fill:#080a0c;}.cls-6{fill:#42484e;}.cls-7{fill:#767c81;}.cls-8{fill:#464c52;}.cls-9{fill:#656b72;}.cls-10{fill:#43494f;}.cls-11{fill:#32373b;}.cls-12{fill:#383d43;}.cls-13{fill:#0a90d0;}.cls-14{fill:#f90;}.cls-15,.cls-16{fill:#fff;}.cls-17{fill:#666;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AdMoblilize - Logo-12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.78 19.02 26.3 20 13.33 46.4 61.01 27.67 26.78 19.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "61.01 27.67 88.52 64.54 69.66 30.19 61.01 27.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.65 77.39 88.52 64.54 61.01 27.67 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.65 77.39 13.33 46.4 61.01 27.67 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 57.09 13.33 46.4 14.65 94.09 0 57.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.65 77.39 13.33 46.4 14.65 94.09 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "54.65 77.39 60.17 102.97 14.65 94.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.65 77.39 60.17 102.97 88.52 64.54 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 57.09 13.33 46.4 26.78 19.02 0 57.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "26.78 19.02 26.3 20 13.33 46.4 61.01 27.67 26.78 19.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "61.01 27.67 88.52 64.54 69.66 30.19 61.01 27.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "54.65 77.39 88.52 64.54 61.01 27.67 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "54.65 77.39 13.33 46.4 61.01 27.67 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "0 57.09 13.33 46.4 14.65 94.09 0 57.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "54.65 77.39 13.33 46.4 14.65 94.09 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "54.65 77.39 60.17 102.97 14.65 94.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "54.65 77.39 60.17 102.97 88.52 64.54 54.65 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0 57.09 13.33 46.4 26.78 19.02 0 57.09"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "63.96 0 63.48 0.98 50.5 27.38 98.19 8.65 63.96 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.19 8.65 125.69 45.52 106.83 11.17 98.19 8.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.82 58.37 125.69 45.52 98.19 8.65 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.82 58.37 50.5 27.38 98.19 8.65 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "37.17 38.07 50.5 27.38 51.83 75.06 37.17 38.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.82 58.37 50.5 27.38 51.83 75.06 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "91.82 58.37 97.34 83.95 51.83 75.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.82 58.37 97.34 83.95 125.69 45.52 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "37.17 38.07 50.5 27.38 63.96 0 37.17 38.07"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.96 0 63.48 0.98 50.5 27.38 98.19 8.65 63.96 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.19 8.65 125.69 45.52 106.83 11.17 98.19 8.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91.82 58.37 125.69 45.52 98.19 8.65 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "91.82 58.37 50.5 27.38 98.19 8.65 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "37.17 38.07 50.5 27.38 51.83 75.06 37.17 38.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "91.82 58.37 50.5 27.38 51.83 75.06 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "91.82 58.37 97.34 83.95 51.83 75.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "91.82 58.37 97.34 83.95 125.69 45.52 91.82 58.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "37.17 38.07 50.5 27.38 63.96 0 37.17 38.07"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "63.96 35.41 63.48 36.39 50.5 62.8 98.19 44.06 63.96 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "98.19 44.06 125.69 80.94 106.83 46.58 98.19 44.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "91.82 93.79 125.69 80.94 98.19 44.06 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "91.82 93.79 50.5 62.8 98.19 44.06 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "37.17 73.49 50.5 62.8 51.83 110.48 37.17 73.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "91.82 93.79 50.5 62.8 51.83 110.48 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "91.82 93.79 97.34 119.37 51.83 110.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "91.82 93.79 97.34 119.37 125.69 80.94 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "37.17 73.49 50.5 62.8 63.96 35.41 37.17 73.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.96 35.41 63.48 36.39 50.5 62.8 98.19 44.06 63.96 35.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.19 44.06 125.69 80.94 106.83 46.58 98.19 44.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91.82 93.79 125.69 80.94 98.19 44.06 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "91.82 93.79 50.5 62.8 98.19 44.06 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "37.17 73.49 50.5 62.8 51.83 110.48 37.17 73.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "91.82 93.79 50.5 62.8 51.83 110.48 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "91.82 93.79 97.34 119.37 51.83 110.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "91.82 93.79 97.34 119.37 125.69 80.94 91.82 93.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "37.17 73.49 50.5 62.8 63.96 35.41 37.17 73.49"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M106,44.14a14.22,14.22,0,0,1,7.37,5.48,19.35,19.35,0,0,1,3.08,7,33.33,33.33,0,0,1,.82,7.15,28.78,28.78,0,0,1-3.46,14.6q-4.7,8.05-14.49,8.06H80.72V43.2H99.35a22.53,22.53,0,0,1,6.68.94M89.49,50.7V78.9h8.33q6.41,0,8.92-6.3a22,22,0,0,0,1.39-8.24c0-4.4-.7-7.77-2.07-10.13s-4.13-3.53-8.24-3.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "61.53 43.2 51.17 43.2 35.53 86.4 45.11 86.4 48.08 77.31 48.12 77.31 50.61 69.35 50.56 69.35 56.25 52.11 61.78 69.35 61.74 69.35 64.16 77.31 64.21 77.31 67.1 86.4 77.02 86.4 61.53 43.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M119.77,60.85l-19.2-35-8.8-2.57-34.84-8.8L29.66,53.27,44.44,90.59h0l46.76,9ZM99.88,26.75l12,21.76L94.4,25.15ZM45.3,42.67,90.54,24.9l-6,47.17Zm38,31L45.55,89.42,44.31,44.47Zm8.18,23.88-5-23L116.89,63Zm1-71.61,25.68,34.43-31.63,12ZM57.35,16l.13-.25,31,7.82L45.3,40.48Zm-2.72,3L42.42,41.74,34.62,48ZM30.89,53.6l11.38-9.13L43.4,85.19Zm15,36.61L85,74.44,90.17,98.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "155.18 65.01 141.49 45.06 136.49 45.06 136.49 85.99 141.81 85.99 141.81 54.96 155.18 74.11 168.56 54.96 168.56 85.99 173.94 85.99 173.94 45.06 168.88 45.06 155.18 65.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M192.45,54c-5.53,0-14.8,2.11-14.8,16.23s9.27,16.24,14.8,16.24,14.79-2.11,14.79-16.24S198,54,192.45,54Zm0,27.33c-6.47,0-9.48-3.53-9.48-11.1s3-11.1,9.48-11.1,9.47,3.43,9.47,11.1S199,81.33,192.45,81.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M224.76,54a25.87,25.87,0,0,0-7,1V43.27h-5.38V76.22c0,1.71.62,10.25,12.82,10.25,5.28,0,14.14-2.14,14.14-16.48C239.32,59.68,234.15,54,224.76,54Zm.42,27.33c-4.73,0-7.44-1.82-7.44-5V60.43a20.48,20.48,0,0,1,7-1.23c6.43,0,9.18,3.22,9.18,10.79C233.94,80.15,228.94,81.33,225.18,81.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 244.91,
    y: 54.53,
    width: 5.32,
    height: 31.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 244.73,
    y: 44.71,
    width: 5.68,
    height: 6.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 256.38,
    y: 43.33,
    width: 5.38,
    height: 42.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 267.73,
    y: 44.71,
    width: 5.68,
    height: 6.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 267.91,
    y: 54.53,
    width: 5.32,
    height: 31.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M301.52,58.69V54.53H278.45v5.08H294.3q-8.08,10.92-16.09,21.84l-.23.32V86h23.78V81H285.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M318.37,54.06c-10.42,0-14.14,8.66-14.14,16.77,0,13.55,9.39,15.58,15,15.58a25.59,25.59,0,0,0,10.21-2l.69-.32V78.28l-1.76,1a19.63,19.63,0,0,1-8.9,1.89c-5.62,0-8.56-2.16-9.25-6.78l-.08-.28a5.65,5.65,0,0,1-.29-.93h21l1.18.11V72.08a11.91,11.91,0,0,0,.07-1.67C332.09,62.5,328.49,54.06,318.37,54.06Zm-.18,5.19c6.82,0,8.15,6,8.4,8.89H309.76C310.33,62.24,313.16,59.25,318.19,59.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdlogoH);
export default __webpack_public_path__ + "static/media/adlogo_h.e9c3257bc847d307cfd9260290a87754.svg";
export { ForwardRef as ReactComponent };